export default __webpack_public_path__ + "static/media/poonawala-stud-farms-logo-transparent.fb1d385e.png";